export const comments_3389320 = {"data":{"data":[],"links":{}}}